const Color = {
  dark: '#13191f',
  darkTwo: '#19222a',
  darkGreyBlue: '#334454',
  desktopBackground: '#1f2b35',
  tangaroa: '#1f2b35',
  white: '#FFFFFF',
  grey: '#8f959a',
  offWhite: '#FCFEFE',
  whiteFaded: 'rgba(255, 255, 255, 0.07)',
  whiteDimmed: 'rgba(255, 255, 255, 0.2)',
  darkFaded: 'rgba(19, 25, 31, 0.2)',
  slate: '#465e74',
  slateGrey: '#576571',
  indicators: '#2E3943',
  listItem: '#2E3943',
  coolBlue: '#14bad8',
  coolBlueDark: '#197286',
  darkBlue: '#13191f',
  mediumGrey: '#c9d4df',
  innerBlue: '#1c262f',
  red: '#ff0000',
  dullRed: '#bb3f3f99',
  yellow: '#ffaa00',
  yellowAlt: '#ffa600',
  warning: '#fab828',
  error: '#BB3F3F',
  waterDepthPopupTitle: '#f7c100',
  warningFaded: 'rgb(250, 184, 40, 0.07)',
  green: '#009900',
  activeThumb: '#FFFFFF',
  active: '#009900',
  inactiveThumb: '#334454',
  inactive: '#171a1c',
  modalBorder: '#26333f',
  modalHighlight: '#1f2b35',
};

export default Color;
